import type { FieldValues } from 'react-hook-form';
import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';
import isCustomFieldId from '@/utils/isCustomFieldId';

const mapFormDataToColumns = (formData: FieldValues) => {
  const columns: ConstituentSearchColumn[] = [];
  const customFieldColumns: string[] = [];

  Object.entries(formData).forEach(([key, value]) => {
    if (isCustomFieldId(key)) {
      if (value) {
        customFieldColumns.push(key);
      }
    } else if (
      key === ConstituentSearchColumn.CONSTITUENT_CATEGORIES &&
      value
    ) {
      /**
       * Categories and rules are controlled together by the CONSTITUENT_CATEGORIES
       * option in the UI. If CONSTITUENT_CATEGORIES is selected, we return both
       * columns from the function.
       */
      columns.push(
        ConstituentSearchColumn.CONSTITUENT_CATEGORIES,
        ConstituentSearchColumn.CONSTITUENT_RULES,
      );
    } else if (value) {
      columns.push(key as ConstituentSearchColumn);
    }
  });

  if (customFieldColumns.length) {
    columns.push(ConstituentSearchColumn.CUSTOM_FIELDS);
  }

  return { columns, customFieldColumns };
};

export default mapFormDataToColumns;
